
//import 'core-js/stable'
//import 'regenerator-runtime/runtime'

import * as aggrModule from "../aggr_module";
import * as commonUtils from "../common_utils";
import * as http from "../http";
import * as utils from "../utils";
console.log("AggModule.........seshanka.....hello2345");
/* window.jQuery = $;
window.$ = $; */

//import {DataManagerFactory}  from "../aggr_module/data_manager/data_manager_factory";
//export default DataManagerFactory;

/** A polifill function for the window CustomEvent object which is not available in IE-11. 
 * We use this to trigger a global even to show the error layer with noodle id 
 * Clients are required to listen this and implement as per their need*/
// istanbul ignore next
(function () {
    // istanbul ignore next
    if (typeof window.CustomEvent === "function")
        return false;
    // istanbul ignore next    
    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    // istanbul ignore next
    window.CustomEvent = CustomEvent;
})();
/** A Promise related event listener, will listen a 'unhandledrejection' event, being triggered when there is no 'reject' handler exists/defined */
// istanbul ignore next
window.addEventListener("unhandledrejection", function (event) {
    // istanbul ignore next
    if (event.reason && event.reason.service === "PASCAL_SERVICE") {
        // istanbul ignore next
        photoOrg.clientLogger && photoOrg.clientLogger.error({ description: 'LIBRARY:DataManagerFactory', errorCode: 'UNHANDLED PROMISE REJECTION', err_desc: JSON.stringify(event.reason) });
    }
    else {
        // istanbul ignore next
        console.log("unhandledrejection from non-library origin sources, reason :  " + event.reason);
    }
    // istanbul ignore next
    event.preventDefault();
});

window.AggrModule = {
    ...aggrModule,
    ...commonUtils,
    ...http,
    ...utils
};